
import { listStoreBuilder } from '@/main/store/pages/list/builder';

import { ServiceJobsDropDownListItem } from '@/main/store/@types/dropdown.d';

import { NAME as name, CRUMB_LABEL_KEY } from '../constants';
import { apiProvider } from '../api';


const filter = {
	DateFrom: null as Date | null,
	DateTo: null as Date | null,
	WorkshopId: [1] as number [],
	OrderType: [] as string[],
	ServiceJobs: [] as ServiceJobsDropDownListItem[],
	FilteredServiceJobs: [] as ServiceJobsDropDownListItem[],
	Brand: null as string | null,
};

export const store = listStoreBuilder({
	name,
	apiProvider,
	crumbLabel: CRUMB_LABEL_KEY,
	dropdownList: {
		WorkshopId: [],
		OrderType: [],
		ServiceJobs: [],
		FilteredServiceJobs: [],
		Brand: [],
	},
	filter,
	tableSetting: {
		isEditable: true,
		columnSettings: {
			VALUE: { isEditable: true, required: true },
		},
	},
	localState: {},
	rowDetail: null,
	extraActions: {},
	extraGetters: {},
	extraMutations: {},
	props: {
		mode: null,
		filter: {},
		afterRowSelection: () => {},
	},
});
